export default __webpack_public_path__ + "static/media/logo.f5f33430.svg";